// extracted by mini-css-extract-plugin
export var root = "H_vY";
export var wrapper = "H_sD";
export var image = "H_vZ d_w d_y d_W";
export var imageWithHeight = "H_v0";
export var crop = "H_v1";
export var round = "H_v2";
export var fixedHeight = "H_v3";